module.exports = __webpack_public_path__ + "static/icon-people@2x-8a18e9ba5f8192106997ab70096e193a.png";